export default {
  en: {
    actions: {
      crop: 'Crop',
    },
    aria_new: {
      upload: 'Upload',
    },
    placeholder: 'Drop file here or click to upload',
    recommended_size: 'Recommended size:',
    snack: {
      exceeds_the_limit_msg:
        'The file size exceeds the limit allowed. Maximum file size is %{limit} kb',
      generic_error_msg: 'Something went wrong',
      import_error: 'Could not load a file',
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
  },
};
